var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternDotsHorizontal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 83,
    viewBox: "0 0 298 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7016 28.945C52.1639 28.9513 53.3263 30.1235 53.32 31.5858C53.3138 33.0479 52.1402 34.2146 50.7282 34.2612C49.272 34.2511 48.1106 33.0828 48.0605 31.6762C48.1239 30.1253 49.2706 28.9389 50.7016 28.945Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3525 31.515L63.3525 31.5076L63.3523 31.5003C63.3097 30.0928 64.4307 28.8899 65.8801 28.8961C67.3421 28.9023 68.5088 30.076 68.5554 31.488C68.5452 32.9466 67.3732 34.1093 65.9636 34.1559C64.5047 34.1457 63.3462 32.9749 63.3525 31.515Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1136 28.7905C82.5759 28.7967 83.7383 29.969 83.7321 31.4314C83.7259 32.8937 82.5536 34.056 81.0912 34.0498C79.6314 34.0436 78.4704 32.8752 78.4727 31.4163C78.532 29.984 79.6715 28.7843 81.1136 28.7905Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3517 28.6859C97.8162 28.6922 98.9845 29.8699 99.0272 31.2852C99.0691 32.6714 97.857 33.8952 96.3862 33.8889C94.9238 33.8827 93.7614 32.7104 93.7677 31.2481C93.7734 29.8884 94.8998 28.6798 96.3517 28.6859Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.539 28.6374C112.998 28.6476 114.156 29.8184 114.15 31.2783C114.144 32.7403 112.97 33.907 111.558 33.9536C110.099 33.9435 108.941 32.7726 108.947 31.3128C108.953 29.8507 110.127 28.6841 111.539 28.6374Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.242 31.1515L124.242 31.1442L124.242 31.1368C124.2 29.7503 125.357 28.5795 126.777 28.5326C128.236 28.5428 129.398 29.7148 129.445 31.1244C129.435 32.583 128.263 33.7459 126.853 33.7924C125.394 33.7822 124.236 32.6114 124.242 31.1515Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.365 31.1519C139.375 29.6933 140.547 28.5305 141.957 28.484C143.415 28.4941 144.578 29.6662 144.625 31.0758C144.615 32.5344 143.443 33.6972 142.033 33.7437C140.574 33.7336 139.411 32.5615 139.365 31.1519Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.193 28.3795C158.652 28.3896 159.815 29.5617 159.861 30.9713C159.851 32.4302 158.68 33.5886 157.221 33.5824C155.761 33.5761 154.596 32.4066 154.545 30.9979C154.608 29.5899 155.784 28.426 157.193 28.3795Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M172.371 28.3303C173.83 28.3405 174.993 29.5125 175.039 30.9222C175.029 32.3807 173.857 33.5435 172.447 33.59C170.989 33.5799 169.826 32.4079 169.78 30.9983C169.79 29.5397 170.962 28.3768 172.371 28.3303Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M185.072 30.9568L185.072 30.9568L185.072 30.943C185.03 29.4318 186.197 28.2753 187.657 28.2815C189.119 28.2877 190.281 29.4601 190.275 30.9224C190.269 32.3844 189.095 33.551 187.683 33.5976C186.224 33.5875 185.066 32.4167 185.072 30.9568Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M202.836 28.2329C204.298 28.2391 205.461 29.4114 205.454 30.8738C205.448 32.3383 204.27 33.5065 202.855 33.5492C201.469 33.5911 200.242 32.3779 200.194 30.9572C200.205 29.3751 201.386 28.2267 202.836 28.2329Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.071 28.1285C219.533 28.1347 220.7 29.3083 220.746 30.7203C220.736 32.1789 219.564 33.3418 218.154 33.3883C216.694 33.3781 215.529 32.2023 215.486 30.7896C215.444 29.2786 216.611 28.1223 218.071 28.1285Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M230.722 30.5845L230.722 30.5771L230.722 30.5697C230.68 29.1835 231.835 28.0161 233.306 28.0224C234.768 28.0286 235.935 29.2022 235.982 30.6143C235.971 32.0731 234.801 33.2316 233.341 33.2254C231.878 33.2191 230.716 32.0468 230.722 30.5845Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M248.49 27.975C249.952 27.9812 251.115 29.1535 251.109 30.6159C251.102 32.0782 249.93 33.2406 248.468 33.2344C247.008 33.2282 245.843 32.0583 245.793 30.6493C245.856 29.1193 247.04 27.9688 248.49 27.975Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6517 14.2187C52.114 14.2249 53.2764 15.3972 53.2702 16.8596C53.2639 18.3219 52.0917 19.4843 50.6293 19.478C49.1694 19.4718 48.0085 18.3034 48.0108 16.8445C48.07 15.4122 49.2096 14.2126 50.6517 14.2187Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3027 16.7899L63.3027 16.7825L63.3025 16.7752C63.2599 15.3677 64.3809 14.1648 65.8303 14.171C67.2923 14.1772 68.459 15.3508 68.5056 16.7629C68.4955 18.2214 67.3234 19.3843 65.9138 19.4308C64.4549 19.4206 63.2964 18.2498 63.3027 16.7899Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0649 14.0648C82.5273 14.071 83.6896 15.2433 83.6833 16.7056C83.6771 18.1677 82.5035 19.3344 81.0915 19.381C79.6327 19.3709 78.4742 18.2 78.4804 16.7402C78.4867 15.2569 79.623 14.0587 81.0649 14.0648Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2435 14.0168C97.7058 14.023 98.8682 15.1953 98.862 16.6576C98.8558 18.12 97.6834 19.2824 96.2211 19.2761C94.7612 19.2699 93.6003 18.1015 93.6026 16.6426C93.6618 15.2103 94.8014 14.0106 96.2435 14.0168Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.491 13.9119C112.95 13.9221 114.113 15.0941 114.159 16.5038C114.149 17.9626 112.978 19.1211 111.518 19.1149C110.059 19.1086 108.894 17.9391 108.843 16.5304C108.906 15.1224 110.082 13.9585 111.491 13.9119Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M126.669 13.8628C128.128 13.8729 129.291 15.045 129.337 16.4546C129.327 17.9132 128.155 19.076 126.745 19.1225C125.287 19.1124 124.124 17.9404 124.077 16.5307C124.088 15.0722 125.26 13.9093 126.669 13.8628Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M139.312 16.4187C139.271 15.0325 140.484 13.8052 141.905 13.7581C143.363 13.7683 144.526 14.9403 144.572 16.35C144.562 17.8086 143.39 18.9714 141.981 19.0179C140.519 19.0078 139.355 17.8316 139.312 16.4187Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M154.492 16.3762C154.503 14.9176 155.675 13.7548 157.084 13.7082C158.543 13.7184 159.706 14.8904 159.752 16.3C159.742 17.7586 158.57 18.9215 157.16 18.968C155.702 18.9579 154.539 17.7858 154.492 16.3762Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M169.73 16.1655C169.736 14.8266 170.899 13.6504 172.321 13.6035C173.78 13.6136 174.943 14.7857 174.989 16.1953C174.979 17.6542 173.808 18.8126 172.349 18.8064C170.886 18.8002 169.724 17.6279 169.73 16.1655Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M187.556 13.4986C189.015 13.5088 190.173 14.6796 190.167 16.1395C190.161 17.6015 188.987 18.7682 187.575 18.8148C186.116 18.8046 184.953 17.6326 184.907 16.2229C184.917 14.7644 186.146 13.5454 187.556 13.4986Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M202.784 13.5061C204.246 13.5123 205.413 14.6859 205.46 16.0979C205.449 17.5565 204.278 18.7193 202.868 18.7658C201.407 18.7557 200.243 17.5798 200.2 16.1671C200.158 14.6562 201.325 13.4999 202.784 13.5061Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M218.022 13.4018C219.484 13.4081 220.65 14.5817 220.697 15.9937C220.687 17.4522 219.515 18.6151 218.105 18.6616C216.644 18.6514 215.48 17.4755 215.437 16.0628C215.395 14.5519 216.562 13.3956 218.022 13.4018Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M230.675 15.9722L230.675 15.9579L230.674 15.9437C230.584 14.5084 231.734 13.347 233.202 13.3533C234.664 13.3595 235.831 14.5331 235.878 15.9451C235.868 17.4037 234.695 18.5665 233.286 18.613C231.827 18.6029 230.669 17.4321 230.675 15.9722Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M248.435 13.2476C249.897 13.2538 251.06 14.4261 251.053 15.8885C251.047 17.3508 249.875 18.5132 248.412 18.5069C246.953 18.5007 245.788 17.3309 245.737 15.9219C245.8 14.3919 246.984 13.2414 248.435 13.2476Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5413 -0.450647C52.0037 -0.444424 53.1661 0.7279 53.1598 2.19023C53.1536 3.65257 51.9813 4.81495 50.519 4.80873C49.0566 4.80251 47.8942 3.63018 47.9005 2.16785C47.9067 0.705517 49.079 -0.45687 50.5413 -0.450647Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7797 -0.55559C67.2421 -0.549367 68.4045 0.622957 68.3982 2.08529C68.392 3.54732 67.2184 4.71401 65.8063 4.76061C64.3475 4.75047 63.189 3.57964 63.1952 2.11977C63.2015 0.636455 64.3378 -0.561727 65.7797 -0.55559Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9596 -0.604315C82.4217 -0.598093 83.5883 0.575555 83.6349 1.98758C83.6248 3.44615 82.4528 4.60894 81.0431 4.65547C79.5845 4.64533 78.4218 3.47334 78.3752 2.06371C78.3853 0.583786 79.5202 -0.610441 80.9596 -0.604315Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M96.195 -0.709401C97.657 -0.703179 98.8237 0.470448 98.8703 1.88246C98.8602 3.34103 97.6881 4.50386 96.2785 4.55038C94.8199 4.54024 93.6571 3.36816 93.6105 1.95852C93.6206 0.478621 94.7555 -0.715527 96.195 -0.709401Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M111.377 -0.758197C112.839 -0.751975 114.005 0.421583 114.052 1.83359C114.042 3.29245 112.871 4.45091 111.411 4.44469C109.952 4.43848 108.786 3.26897 108.736 1.86024C108.799 0.431158 109.937 -0.764324 111.377 -0.758197Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M126.619 -0.863293C128.078 -0.853153 129.241 0.318873 129.287 1.72849C129.277 3.18734 128.106 4.3458 126.646 4.33959C125.187 4.33338 124.022 3.16382 123.971 1.7551C124.034 0.347097 125.21 -0.816771 126.619 -0.863293Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M141.789 -0.912756C143.251 -0.906533 144.414 0.26579 144.407 1.72812C144.401 3.19015 143.228 4.35677 141.816 4.40337C140.359 4.39325 139.198 3.22501 139.148 1.81846C139.212 0.278021 140.461 -0.918408 141.789 -0.912756Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M154.443 1.65037C154.453 0.191782 155.625 -0.971094 157.034 -1.01762C158.493 -1.00748 159.656 0.164589 159.702 1.57423C159.692 3.0328 158.52 4.19563 157.11 4.24216C155.652 4.23201 154.489 3.06001 154.443 1.65037Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M172.269 -1.12164C173.73 -1.11148 174.895 0.0646644 174.937 1.47759C174.979 2.86379 173.767 4.08757 172.296 4.08131C170.834 4.07509 169.672 2.90277 169.678 1.44043C169.684 0.101519 170.847 -1.07472 172.269 -1.12164Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M187.448 -1.17175C188.907 -1.16161 190.065 0.0091527 190.059 1.46902C190.053 2.93135 188.88 4.09374 187.418 4.08752C185.953 4.08128 184.785 2.90362 184.742 1.48831C184.701 0.121532 186.006 -1.12407 187.448 -1.17175Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M200.092 1.39152C200.102 -0.0670519 201.274 -1.22988 202.684 -1.27641C204.142 -1.26627 205.305 -0.0942 205.352 1.31544C205.342 2.77401 204.17 3.93684 202.76 3.98337C201.301 3.97322 200.139 2.80115 200.092 1.39152Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M215.387 1.3511L215.387 1.33682L215.386 1.32257C215.297 -0.112703 216.446 -1.27413 217.915 -1.26788C219.377 -1.26166 220.543 -0.0880135 220.59 1.32401C220.58 2.78258 219.408 3.94541 217.998 3.99193C216.539 3.9818 215.381 2.81096 215.387 1.3511Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M233.151 -1.37221C234.614 -1.36599 235.776 -0.193731 235.77 1.2686C235.763 2.73093 234.591 3.89332 233.129 3.8871C231.666 3.88088 230.504 2.70862 230.51 1.24629C230.517 -0.216044 231.689 -1.37843 233.151 -1.37221Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M248.331 -1.42195C249.793 -1.41572 250.956 -0.243399 250.949 1.21893C250.943 2.68351 249.765 3.85171 248.35 3.89449C246.964 3.93638 245.737 2.7231 245.69 1.3024C245.7 -0.279681 246.881 -1.42812 248.331 -1.42195Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.857532
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternDotsHorizontal);
export default __webpack_public_path__ + "static/media/pattern-dots-horizontal.82e15cb25208e1793f0b28656dae822a.svg";
export { ForwardRef as ReactComponent };